export enum BillingType {
  Own = 'own',
  External = 'external',
}
